module.exports = __webpack_public_path__ + "img/logo.6fb20b94.jpg";